import { Gewerk } from '@myapp/contract'
import { EntitySearchSelect } from '../../../shared/ui/search/EntitySearchSelect/EntitySearchSelect'
import { useGewerkeInfiniteQuery } from '../api/queries/useGewerkeInfiniteQuery'
import { useGewerkDetail } from '../api/queries/useGewerkDetail'

interface GewerkSearchSelectProps {
  value: number | null | undefined
  onChange: (id: number | null, item?: Gewerk) => void
  disabled?: boolean
  readOnly?: boolean
  /** Validation message, passed straight through — see `EntitySearchSelect.error`. */
  error?: string | null
  /** A `Controller`'s `field.ref`, so react-hook-form can focus this field on a failed submit. */
  inputRef?: React.Ref<HTMLInputElement | HTMLTextAreaElement>
  className?: string
  placeholder?: string
}

export function GewerkSearchSelect({
  value,
  onChange,
  disabled,
  readOnly,
  error,
  inputRef,
  className,
  placeholder = 'Gewerk suchen…',
}: GewerkSearchSelectProps) {
  return (
    <EntitySearchSelect<Gewerk>
      value={value}
      onChange={onChange}
      useInfiniteHook={useGewerkeInfiniteQuery}
      useDetailHook={useGewerkDetail}
      searchParamName="search"
      getLabel={(g) => g.text}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      error={error}
      inputRef={inputRef}
      className={className}
    />
  )
}
